import { PageHeader } from '@/components/layout/PageHeader'

export default function InboxPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Inbox" description="View your notifications and activity" />
      <div className="text-muted-foreground">Inbox content coming soon...</div>
    </div>
  )
}
